import { HeadlinerLogoLight, Spacer } from '@sparemin/blockhead';
import styled from 'styled-components';
import smallImage from 'assets/authPageBackgroundImage/bgimg.jpg';
import mediumImage from 'assets/authPageBackgroundImage/bgimg@2x.jpg';
import largeImage from 'assets/authPageBackgroundImage/bgimg@3x.jpg';

export const Background = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-image: image-set(
    url(${smallImage}) 1x,
    url(${mediumImage}) 2x,
    url(${largeImage}) 3x
  );
`;

export const Container = styled(Spacer)`
  width: 100%;
  height: 100%;
`;

export const Logo = styled(HeadlinerLogoLight)`
  width: 188px;
  height: 40px;
  margin: 0 0 24px;
`;
